import theme from '../../base';

const link = {
  focus: {
    border: theme.colors.blues.blue700,
  },
  primary: {
    foreground: theme.colors.blues.blue700,
    foregroundHover: theme.colors.blues.blue500,
    foregroundActive: theme.colors.blues.blue700,
  },
  secondary: {
    foreground: theme.colors.neutrals.gray800,
    foregroundHover: theme.colors.neutrals.gray700,
    foregroundActive: theme.colors.neutrals.gray800,
  },
};

export default link;
